import { useContext } from 'react';

import { CurrentAssetsContext } from '../providers/current-assets';

export function useCurrentAssets() {
  return useContext(CurrentAssetsContext);
}
